import React from "react";
import BrandHeading from "./BrandHeading";
import { Box, Center, SimpleGrid } from "@chakra-ui/react";
import { GatsbyImage, getImage as getGatsbyImage } from "gatsby-plugin-image";

import { graphql, useStaticQuery } from "gatsby";
import ResponsiveContainer from "./ResponsiveContainer";
import { brading } from "@modules/HomePage/models/industryLeader";
import { BrandHeadingHero } from "../style";

const getImage = (node: any) => {
  if (!node) {
    return;
  }

  return getGatsbyImage(node);
};

const IndustryLeader = () => {
  const data = useStaticQuery(LeaderStaticQuery);

  const listLeader = [
    {
      image: getImage(data.sprint)!,
      alt: "sprint",
    },
    {
      image: getImage(data.att)!,
      alt: "att",
    },
    {
      image: getImage(data.bt)!,
      alt: "bt",
    },
    {
      image: getImage(data.lumen)!,
      alt: "lumen",
    },
    {
      image: getImage(data.hp)!,
      alt: "hp",
    },
    {
      image: getImage(data.ibm)!,
      alt: "ibm",
    },
    {
      image: getImage(data.verizon)!,
      alt: "verizon",
    },
  ];

  return (
    <ResponsiveContainer>
      <BrandHeadingHero>
        <Box
          textAlign={{ md: "center" }}
          maxW={{ base: "100%", md: "80%", lg: "60%", xl: "50%" }}
          mb={10}
          mx={"auto"}
        >
          <BrandHeading heading={brading} />
        </Box>
      </BrandHeadingHero>

      <SimpleGrid columns={{ base: 3, lg: 7 }} spacing={2} my={14}>
        {listLeader.map((item, index) => (
          <Center key={index} py={2} mx={4}>
            <GatsbyImage
              image={item.image}
              alt={item.alt}
              loading="lazy"
              imgStyle={{ objectFit: "contain" }}
            />
          </Center>
        ))}
      </SimpleGrid>
    </ResponsiveContainer>
  );
};

export default IndustryLeader;

export const ImageData = graphql`
  fragment ImageData on File {
    childImageSharp {
      gatsbyImageData(layout: FIXED, placeholder: BLURRED)
    }
  }
`;

const LeaderStaticQuery = graphql`
  query {
    sprint: file(relativePath: { eq: "i_TMobile.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 137, height: 51) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    att: file(relativePath: { eq: "i_att.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 148, height: 61) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    bt: file(relativePath: { eq: "i_bt.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 60, height: 61) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    lumen: file(relativePath: { eq: "i_lumen.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 183, height: 49) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    hp: file(relativePath: { eq: "i_hp.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 61, height: 61) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    ibm: file(relativePath: { eq: "i_ibm.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 93, height: 37) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    verizon: file(relativePath: { eq: "i_verizon.png" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 170, height: 39) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
